import { LinkButton, UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { Advantages } from 'shared/components/Advantages';
import { Content, FullscreenPopup, Header } from 'shared/components/Advantages/components/FullscreenPopup';
import {
  getGaLabel,
  getNewbuildingAdvantages,
  getNewbuildingLink,
  getNewbuildingName,
} from 'shared/selectors/newObject';

import { trackAdvantagesItemClick, trackNewbuildingLinkClick } from './tracking';

export const NewbuildingAdvantages = () => {
  const name = useSelector(getNewbuildingName);
  const advantages = useSelector(getNewbuildingAdvantages);
  const newbuildingLink = useSelector(getNewbuildingLink);
  const gaLabel = useSelector(getGaLabel);

  const [isOpened, setOpenedState] = React.useState(false);
  const [advantageIndex, setAdvantageIndex] = React.useState(0);

  const onItemClick = React.useCallback(
    (i: number) => {
      setAdvantageIndex(i);
      setOpenedState(true);

      const item = advantages[i];
      if (item) {
        trackAdvantagesItemClick(item.advantageType);
      }
    },
    [setOpenedState, setAdvantageIndex, advantages],
  );

  const onNewbuildingLinkClick = React.useCallback(() => trackNewbuildingLinkClick(gaLabel), [gaLabel]);

  const onClose = React.useCallback(() => {
    setOpenedState(false);
  }, [setOpenedState]);

  if (!advantages || advantages.length === 0) {
    return null;
  }

  const advantage = advantages[advantageIndex];

  return (
    <>
      <Advantages
        advantages={advantages}
        detailsButton={
          <LinkButton
            target="_blank"
            href={newbuildingLink}
            size="XS"
            theme="stroke_primary"
            onClick={onNewbuildingLinkClick}
          >
            Подробнее о жилом комплексе
          </LinkButton>
        }
        onItemClick={onItemClick}
      />

      <FullscreenPopup
        isOpened={isOpened}
        header={<Header onClose={onClose} title={<UIText1>ЖК «{name}»</UIText1>} />}
        onClose={onClose}
        content={<Content {...advantage} />}
      />
    </>
  );
};
